import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import styles from "./RadioAnswer.module.css";

const RadioAnswer = ({ checked, nextQuestionHandler, value, title, id }) => {
  return (
    <FormControlLabel
      key={id}
      className={`${styles.options} ${checked ? styles.selected : null}`}
      style={{ display: "flex", alignItems: "center" }}
      control={
        <Checkbox
          checked={checked}
          color="success"
          onClick={(e) => {
            nextQuestionHandler(value);
          }}
        />
      }
      label={title}
    />
  );
};

export default RadioAnswer;
